import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../common/constants/urls';
const getScheduleList = teamId => {
  return fetch(urls.schedules.teams.teamId.url({
    teamId
  }));
};
const updateSchedule = ({
  scheduleId,
  description,
  name,
  enabled,
  timezone
}) => {
  return fetch(urls.schedules.scheduleId.url({
    scheduleId
  }), {
    method: 'PATCH',
    body: {
      description,
      name,
      enabled,
      timezone
    }
  });
};
const deleteSchedule = ({
  scheduleId
}) => {
  return fetch(urls.schedules.scheduleId.url({
    scheduleId
  }), {
    method: 'DELETE'
  });
};
export const endpoints = {
  deleteSchedule,
  getScheduleList,
  updateSchedule
};